import React, { useEffect, useState } from "react";
import defaultImg from "../../../assets/images/product/defaultImg.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { fetchBanner } from "../../../Redux/Reducers/BannerReducer";
import toast from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button as MuiButton,
  Tooltip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { usePermissions } from "../../../context/AuthContext";

function Topbanner() {
  const { can } = usePermissions();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const banners = useSelector((state) => state?.BannerReducer?.banner);
  const webBanner =
    banners?.find((b) => b.bannerType === "forWeb")?.heroBanners || [];
  const mobileBanner =
    banners?.find((b) => b.bannerType === "forMobile")?.heroBanners || [];
  const toggleBanner =
    banners?.find((b) => b.bannerType === "forMobileView")?.heroBanners || [];

  const [webImages, setWebImages] = useState([]);
  const [mobileImages, setMobileImages] = useState([]);
  const [toggleImages, setToggleImages] = useState([]);
  const [activeTab, setActiveTab] = useState("web");

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    dispatch(fetchBanner());
  }, [dispatch]);

  useEffect(() => {
    setWebImages(webBanner);
    setMobileImages(mobileBanner);
    setToggleImages(toggleBanner);
  }, [webBanner, mobileBanner, toggleBanner]);

  const getActiveImages = () => {
    if (activeTab === "web") return webImages;
    if (activeTab === "mobile") return mobileImages;
    return toggleImages;
  };

  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleDelete = async () => {
    if (!selectedRow) return;

    let bannerType = activeTab === "web" ? "forWeb" : activeTab === "mobile" ? "forMobile" : "forMobileView";

    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      await axios.delete(
        `${process.env.REACT_APP_BASEURL}/admin/banner/hero/${bannerType}/${selectedRow.id}`,
        { headers: { Authorization: token } }
      );
      toast.success("Banner deleted successfully!");
      dispatch(fetchBanner());
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Failed to delete banner");
    } finally {
      handleCloseDialog();
    }
  };

  const columns = [
    { field: "sno", headerName: "S.No", width: 80 },
    {
      field: "imageUrl",
      headerName: "Banner Image",
      width: 250,
      renderCell: (params) => (
        <img
          src={params.value || defaultImg}
          alt="banner"
          style={{ width: "120px", height: "60px", objectFit: "cover" }}
        />
      ),
    },
    { field: "bannerTitle", headerName: "Title", width: 180 },
    { field: "imageFor", headerName: "For", width: 130 },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: ({ row }) => {
        let editPath = "";
        if (activeTab === "web") editPath = `/web-edit/${row.id}`;
        else if (activeTab === "mobile") editPath = `/app-edit/${row.id}`;
        else editPath = `/mobile-edit/${row.id}`;

        return (
          <div>
            {can('top_banners:edit') && (
              <Tooltip title="Edit Banner">
                <IconButton component={Link} to={editPath}>
                  <i className="icofont-edit text-info"></i>
                </IconButton>
              </Tooltip>
            )}
            {can('top_banners:delete') && (
              <Tooltip title="Delete Banner">
                <IconButton onClick={() => handleOpenDialog(row)}>
                  <i className="icofont-ui-delete text-danger"></i>
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const rows = getActiveImages().map((img, index) => ({
    id: img._id || `row-${index}`,
    sno: index + 1,
    imageUrl: img.imageUrl,
    bannerTitle: img.bannerTitle,
    imageFor: img.imageFor || "-",
  }));

  const getAddButton = () => {
    if (!can('top_banners:add')) return null;

    if (activeTab === "web")
      return <button className="btn btn-primary" onClick={() => navigate("/webView-banners")}>Add Banner</button>;
    if (activeTab === "mobile")
      return <button className="btn btn-primary" onClick={() => navigate("/appView-banners")}>Add Banner</button>;
    return <button className="btn btn-primary" onClick={() => navigate("/mobileView-banners")}>Add Banner</button>;
  };

  return (
    <>
      <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
        <h6 className="mb-0 fw-bold">Top Banner <span style={{ color: "red" }}>*</span></h6>
        {getAddButton()}
      </div>

      <div className="d-flex mb-3">
        <button className={`btn ${activeTab === "web" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setActiveTab("web")}>Web View</button>
        <button className={`btn ms-2 ${activeTab === "mobile" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setActiveTab("mobile")}>App View</button>
        <button className={`btn ms-2 ${activeTab === "toggle" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setActiveTab("toggle")}>Mobile View</button>
      </div>

      <div className="card-body">
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </div>
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this banner?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={handleCloseDialog}>Cancel</MuiButton>
          <MuiButton onClick={handleDelete} color="error">Delete</MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Topbanner;